export default __webpack_public_path__ + "static/media/greeting5.35cea389.png";